module.exports = __webpack_public_path__ + "static/media/wordpress.7bfd9213.png";